import { ApolloCache } from "@apollo/client";

// Root query fields whose results depend on the company's Shopify
// connection. Evicted whenever a connection is added or removed so pages
// like Orders and My Listings refetch instead of serving stale cache.
const CONNECTION_SCOPED_FIELDS = [
  "outgoingSales",
  "purchaseHistory",
  "myShopifyProducts",
  "shopifyInventoryItems",
  "listings",
  "channelPublicationSummary",
  "channelPublishedProducts",
];

export function evictConnectionScopedData(cache: ApolloCache<any>) {
  CONNECTION_SCOPED_FIELDS.forEach((fieldName) => {
    cache.evict({ id: "ROOT_QUERY", fieldName });
  });
  cache.gc();
}
